module.exports = __webpack_public_path__ + "static/media/android_btn.7ab1183c.png";